"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Server response from GET_GLOBAL_PERMISSION_SERVICE request
 */
var ListGlobalPermissionsResult = /** @class */ (function () {
    /**
     * Create a new ListGlobalPermissionsResult instance.
     * @param permissions the set of global permissions
     */
    function ListGlobalPermissionsResult(permissions) {
        this.permissions = permissions;
    }
    return ListGlobalPermissionsResult;
}());
exports.ListGlobalPermissionsResult = ListGlobalPermissionsResult;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/security/list-global-permissions-result.js
// module id = 1973
// module chunks = 1